'use client';

import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import { withAssetPrefix } from '@/lib/assetPrefix';

interface ProjectionConfig {
  scale: number;
  center: [number, number];
}

const PROJECTION_DEFAULTS: Record<string, ProjectionConfig> = {
  germany: { scale: 2400, center: [10.4, 51.2] },
};

interface CountryMapProps {
  country: string;
  hoveredId: string | null;
  onHover: (id: string | null) => void;
  onSelect: (id: string) => void;
}

export const CountryMap = ({
  country,
  hoveredId,
  onHover,
  onSelect,
}: CountryMapProps) => {
  const config = PROJECTION_DEFAULTS[country] ?? {
    scale: 1000,
    center: [0, 0],
  };

  return (
    <ComposableMap
      projection="geoMercator"
      projectionConfig={config}
      className="w-full"
      aria-hidden="true"
    >
      <Geographies geography={withAssetPrefix(`/${country}-states.json`)}>
        {({ geographies }) =>
          geographies.map((geo) => {
            const id = geo.properties.id as string;
            const isHovered = hoveredId === id;
            return (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                onClick={() => onSelect(id)}
                onMouseEnter={() => onHover(id)}
                onMouseLeave={() => onHover(null)}
                tabIndex={-1}
                style={{
                  default: {
                    fill: 'var(--color-primary)',
                    fillOpacity: isHovered ? 0.5 : 1,
                    stroke: '#ffffff',
                    strokeWidth: 0.5,
                    outline: 'none',
                    cursor: 'pointer',
                    transition: 'fill-opacity 0.15s',
                  },
                  hover: {
                    fill: 'var(--color-primary)',
                    fillOpacity: 0.5,
                    stroke: '#ffffff',
                    strokeWidth: 0.5,
                    outline: 'none',
                    cursor: 'pointer',
                  },
                  pressed: {
                    fill: 'var(--color-primary)',
                    fillOpacity: 0.4,
                    stroke: '#ffffff',
                    strokeWidth: 0.5,
                    outline: 'none',
                  },
                }}
              />
            );
          })
        }
      </Geographies>
    </ComposableMap>
  );
};
